import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function EcclesiaPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-[#b8144a] to-[#d91e5b] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">Ecclesia of Believers International</h1>
          <p className="text-xl max-w-4xl mx-auto">
            Apostolic churches and assemblies under one doctrine and spiritual oversight, 
            united in the truth of Christ across nations
          </p>
        </div>
      </section>

      {/* What is EBI */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">The Called-Out Ones</h2>
              <div className="prose prose-lg text-gray-700">
                <p className="text-xl leading-relaxed mb-6">
                  Ecclesia of Believers International (EBI) represents the church planting and apostolic 
                  oversight arm of Peter Akinnubi Apostolic Mandate. EBI establishes and oversees 
                  apostolic churches and assemblies that operate under unified doctrine and spiritual covering.
                </p>
                <p className="text-lg leading-relaxed mb-6">
                  The word "Ecclesia" means "called-out ones" - believers who have been called out of 
                  the world and religious confusion into the truth and order of Christ. EBI churches 
                  are not denominational institutions but living expressions of the Body of Christ, 
                  united by apostolic doctrine and divine purpose.
                </p>
                <blockquote className="text-lg italic text-[#b8144a] border-l-4 border-[#b8144a] pl-6 my-6">
                  "And I also say to you that you are Peter, and on this rock I will build My church, 
                  and the gates of Hades shall not prevail against it." - Matthew 16:18
                </blockquote>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Diverse%20apostolic%20church%20congregation%20in%20worship%20with%20raised%20hands%2C%20multi-ethnic%20believers%20united%20in%20praise%20and%20prayer%2C%20modern%20church%20setting%20with%20warm%20lighting%2C%20representing%20the%20global%20Ecclesia%20of%20believers%20gathered%20under%20apostolic%20oversight%20and%20unified%20doctrine&width=600&height=500&seq=ecclesia-worship-1&orientation=landscape"
                alt="Ecclesia of Believers International"
                className="rounded-lg shadow-2xl object-cover w-full h-96"
              />
            </div>
          </div>
        </div>
      </section>

      {/* EBI Characteristics */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">EBI Church Characteristics</h2>
            <p className="text-xl text-gray-600">What distinguishes an Ecclesia of Believers church</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-open-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Apostolic Doctrine</h3>
              <p className="text-gray-700 text-center">
                Grounded in the doctrine of Christ as taught by the apostles, with emphasis on 
                sound biblical interpretation and Christocentric teaching
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Spiritual Covering</h3>
              <p className="text-gray-700 text-center">
                Operating under apostolic oversight and spiritual accountability, ensuring 
                doctrinal integrity and pastoral care across the network
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-group-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Community Focus</h3>
              <p className="text-gray-700 text-center">
                Emphasis on authentic fellowship, mutual care, and practical Christianity 
                that impacts the local community and beyond
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-follow-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Discipleship Driven</h3>
              <p className="text-gray-700 text-center">
                Committed to making disciples, not just converts, through intentional 
                spiritual formation and leadership development
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-fire-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Spirit Empowered</h3>
              <p className="text-gray-700 text-center">
                Operating in the gifts and power of the Holy Spirit, with emphasis on 
                supernatural ministry and divine intervention
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg">
              <div className="w-16 h-16 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-global-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">Missional Mandate</h3>
              <p className="text-gray-700 text-center">
                Actively engaged in evangelism, church planting, and global missions, 
                fulfilling the Great Commission in their sphere of influence
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Church Planting Process */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Church Planting Process</h2>
            <p className="text-xl text-gray-600">How EBI churches are established and developed</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">1</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Vision and Calling</h3>
              <p className="text-gray-700">
                Identification of called and equipped leaders through the One Fold Network 
                who receive vision for church planting in specific locations
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">2</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Training and Preparation</h3>
              <p className="text-gray-700">
                Intensive preparation including church planting training, doctrinal grounding, 
                and practical ministry skills development
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">3</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Launch and Establishment</h3>
              <p className="text-gray-700">
                Strategic launch with apostolic oversight, initial core team formation, 
                and establishment of regular worship and fellowship
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#b8144a] rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-white text-2xl font-bold">4</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Growth and Multiplication</h3>
              <p className="text-gray-700">
                Ongoing development, leadership multiplication, and preparation for 
                planting additional churches in the region
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Apostolic Oversight Structure */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img 
                src="https://readdy.ai/api/search-image?query=Apostolic%20leadership%20council%20meeting%20with%20diverse%20church%20leaders%20in%20discussion%2C%20spiritual%20oversight%20and%20accountability%20session%2C%20pastors%20and%20apostolic%20leaders%20in%20prayer%20and%20planning%2C%20representing%20church%20governance%20and%20apostolic%20covering%20with%20warm%20professional%20atmosphere&width=600&height=500&seq=apostolic-oversight-1&orientation=landscape"
                alt="Apostolic Oversight"
                className="rounded-lg shadow-2xl object-cover w-full h-96"
              />
            </div>
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Apostolic Oversight Structure</h2>
              <div className="prose prose-lg text-gray-700">
                <p className="text-xl leading-relaxed mb-6">
                  EBI churches operate under a clear apostolic oversight structure that ensures 
                  doctrinal integrity, pastoral care, and strategic coordination across the network.
                </p>
                <div className="space-y-4">
                  <div className="bg-white p-4 rounded-lg border-l-4 border-[#b8144a]">
                    <h4 className="font-bold text-gray-900 mb-2">International Level</h4>
                    <p className="text-gray-700">Apostle Peter Akinnubi provides overall apostolic oversight and vision</p>
                  </div>
                  <div className="bg-white p-4 rounded-lg border-l-4 border-[#b8144a]">
                    <h4 className="font-bold text-gray-900 mb-2">Regional Level</h4>
                    <p className="text-gray-700">Regional apostolic coordinators oversee multiple churches in their areas</p>
                  </div>
                  <div className="bg-white p-4 rounded-lg border-l-4 border-[#b8144a]">
                    <h4 className="font-bold text-gray-900 mb-2">Local Level</h4>
                    <p className="text-gray-700">Local pastors and elders provide day-to-day leadership and pastoral care</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* EBI Churches Worldwide */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">EBI Churches Worldwide</h2>
            <p className="text-xl text-gray-600">Growing network of apostolic churches across continents</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <i className="ri-map-pin-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Africa</h4>
              <p className="text-gray-600 text-sm">Established churches across Nigeria, Ghana, Kenya, and South Africa</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <i className="ri-map-pin-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">North America</h4>
              <p className="text-gray-600 text-sm">Growing presence in United States and Canada</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <i className="ri-map-pin-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Europe</h4>
              <p className="text-gray-600 text-sm">Churches planted in United Kingdom and other European nations</p>
            </div>

            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <i className="ri-map-pin-line text-[#b8144a] text-3xl mb-4"></i>
              <h4 className="font-bold text-gray-900 mb-2">Asia & Others</h4>
              <p className="text-gray-600 text-sm">Emerging works in Asia, Australia, and other regions</p>
            </div>
          </div>
        </div>
      </section>

      {/* Join EBI */}
      <section className="py-20 bg-[#b8144a] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Join the Ecclesia</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Are you called to plant or pastor an apostolic church? Ready to be part of a global 
            network of churches united in doctrine and purpose? Connect with EBI today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/join"
              className="bg-white text-[#b8144a] px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Plant an EBI Church
            </Link>
            <Link 
              to="/cfn"
              className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-[#b8144a] transition-colors whitespace-nowrap cursor-pointer"
            >
              Find Local Church
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}